let _oldVersionElectron = null;
let _newVersionElectronFn = null;
let _newVersionElectronIPC = null;

try {
  // 避免parent无法访问导致页面无法加载
  _oldVersionElectron = window.electron || window.parent.electron;
  _newVersionElectronFn = window.electronFn || window.parent.electronFn;
  _newVersionElectronIPC = window.ipcFn || window.parent.ipcFn;
} catch (e) {
  console.error(e);
}

export const sendToIPC = (event, data) => {
  try {
    if (_oldVersionElectron) {
      _oldVersionElectron.ipcRenderer.send(event, data)
    } else {
      _newVersionElectronIPC.send(event, data)
    }
  } catch (error) {
    console.log(error)
  }
}

export const onIPC = (event, fn) => {
  try {
    if (_oldVersionElectron) {
      _oldVersionElectron.ipcRenderer.on(event, fn)
    } else {
      _newVersionElectronIPC.on(event, fn)
    }
  } catch (error) {
    console.log(error)
  }
}

export const openNewWindow = href => {
  try {
    if (_oldVersionElectron) {
      _oldVersionElectron.shell.openExternal(exePayUrl)
    } else {
      _newVersionElectronFn.openNewWindow(href)
    }
  } catch (error) {
    console.log(error)
  }
}
